<div class="modals" [class.oferta-cookie-show]="isModalOfertaCookieShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <h3 class="header-cookie-text">Політика щодо використання файлів cookie(далі – «політика щодо використання файлів
    cookie»)</h3>

  <hr>

  <h4 class="oferta-text-center">1. ТЕРМІНИ</h4>

  <ul>
    <li>1.1. Термінологія, яка використана в цій Політиці щодо використання файлів cookie,
      має таке ж значення, як і в Угоді Користувача, якщо не зазначено інше.
    </li>
    <li>1.2. <b>Файли cookie</b> – це невеликі фрагменти даних, що містять унікальний ідентифікатор, який надсилається
      сервером Вебсайту
      до Браузера комп’ютера Користувача та зберігаються на жорсткому диску комп’ютера. Кожен вебсайт або сторонній
      постачальник послуг,
      що використовуються Вебсайтом, може надсилати власні Файли cookie до Браузера Користувача, якщо Браузер
      Користувача дозволяє це робити.
      Файли cookie містять анонімну інформацію – унікальний ідентифікатор, назву вебсайту та деякі цифрові та
      статистичні дані,
      які дозволяють вебсайту запам'ятовувати налаштування Користувачів або зберігати Інформацію про товари, додані до
      корзини.
      Файли cookie можуть бути сесійними, що зберігаються на час використання Користувачем того чи іншого сервісу, чи
      зразу видалятися,
      щойно Користувач закриває браузер. Також Файли cookie можуть бути постійними та зберігатися в пам’яті Браузера
      протягом тривалого часу.
    </li>
    <li>1.3. <b>Браузер</b> – це додаток, що дозволяє Користувачам переглядати вебсайти в мережі Інтернет.
      Серед найпопулярніших браузерів – Chrome, Internet Explorer, Firefox, Safari та інш. Більшість браузерів є
      безпечними та дають можливість легко та швидко видалити таку інформацію як cookie.
    </li>
  </ul>

  <h4 class="oferta-text-center">2. ЗАГАЛЬНІ ПОЛОЖЕННЯ</h4>

  <ul>
    <li><b>2.1. Політика щодо викростання файлів cookie є додатком до Угоди Користувача, що розміщена на Вебсайті</b>
      https://maslotochka.com надалі - Вебсайт.
    </li>
    <li>2.2. Ця політка регулює порядок та випадки використання Товариство з обмеженою відповідальністю «Маслоточка»
      (надалі – «Товариство»)
      код ЄДРПОУ 44746445 (надалі також – «Компанія» та/або «Адміністратор») особистої інформації Користувачів на
      Вебсайті а також інструкції,
      використовуючи які Користувач може контролювати використання цих даних.
    </li>
    <li>2.3. Відвідуючи Вебсайт, мобільну версію Вебсайту, Користувач погоджується з використанням Файлів cookie,
      у відповідності до даної Політики щодо використання файлів cookie.
    </li>
    <li>2.4. Якщо Користувач відмовляється використовувати Файли cookie, будь-ласка вимкніть їх в налаштуваннях
      Браузера.
    </li>
    <li>2.5. Використання функціоналу Вебсайту вимагає від Користувачів згоди з положеннями Політики щодо використання
      файлів cookie.
      У разі, якщо ви незгодні з її положеннями, будь-ласка не відвідуйте Вебсайт.
    </li>
  </ul>

  <h4 class="oferta-text-center">3. ЗБІР ІНФОРМАЦІЇ ТА ФАЙЛИ COOKIE, ЩО ВИКОРИСТОВУЮТЬСЯ КОМПАНІЄЮ</h4>

  <ul>
    <li>3.1. Компанією здійснюється збір 2 типів інформації:</li>
    <li>- даних, які отримуються від Користувачів;</li>
    <li>- даних, збір яких здійснюється в автоматичному режимі.</li>
    <li>3.2. Компанія використовує наступні категорії Файлів cookie:</li>
    <li>3.2.1. Обов’язкові (строго необхідні) Файли cookie – потрібні для пересування Користувача вебсторінкою та
      здійснення пошуку по Сайту,
      здійснення запам'ятовування попередніх дій Користувача при переході на попередню сторінку в тій же сесії.
    </li>
    <li>3.2.2. Експлуатаційні Файли cookie – агрегують інформацію про те, як використовується Сайт. Такі дані
      зберігаються на пристрої Користувача
      між сеансами Браузера. Прикладами таких даних можуть бути наступні метрики: час перебування на Сайті, найбільш
      часто відвідувані сторінки,
      розуміння, які саме розділи і сервіси Сайту були найбільш цікаві для Користувача, наскільки ефективна та чи інша
      рекламна та/або
      маркетингова кампанія і т.д. Вся інформація, зібрана за допомогою експлуатаційних Файлів cookie, призначена для
      статистичних та аналітичних
      задач. Деякі дані Файлів cookie можуть надаватися третім сторонам, які мають дозвіл з боку вебресурсу і виключно
      для зазначених вище цілей.
    </li>
    <li>3.2.3. Функціональні Файли cookie – використовуються для збереження параметрів або конфігурацій, які
      зберігаються на пристрої Користувача
      між сеансами Браузера. Дані Файли cookie також дозволяють Користувачам дивитися відео, брати участь в інтерактивах
      (опитування, голосування)
      та взаємодіяти з соціальними мережами. Щоб зробити більш приємними враження після відвідування ресурсу, зазначені
      Файли cookie запам'ятовують
      надану Користувачем інформацію, підвищуючи ефективність взаємодії з Сайтом.
    </li>
    <li>3.2.4. Цільові Файли cookie – використовуються для надання контенту, який може зацікавити Користувача. Ці дані
      зберігаються на пристрої
      Користувача між сеансами Браузера. Прикладами таких даних можуть бути наступні метрики: відстеження
      рекомендованого текстового, графічного,
      аудіо та відеоматеріалу, щоб уникнути повторного показу, управління цільовою рекламою, оцінка ефективності
      рекламних кампаній, інформація про
      відвідування Користувачем інших ресурсів при переходах, а також інші параметри налаштування Сайту. Сайт може
      ділитися цією інформацією з іншими
      сторонами, включаючи медіаклієнтів, рекламодавців, агентств і партнерів по суміжних бізнесах для того, щоб вони
      надавали якісну таргетовану рекламу.
    </li>
    <li>3.2.5. Файли cookie відповідності. Дані Файли cookie необхідні для забезпечення дотримання законних і
      регулятивних вимог, наприклад,
      у галузі боротьби з шахрайством і відмиванням грошей. Вони також не допускають використання вашого облікового
      запису іншими Користувачами.
      Файли cookie активуються при відвідуванні Вебсайту і залишаються активними протягом усього сеансу.
    </li>
    <li>3.2.6. Сookie-файли сторонніх сервісів і сервісів аналітики. Дані Файли cookie додаються на Вебсайт третіми
      сторонами, наприклад, YouTube
      або Twitter, якщо там є вбудований контент третіх сторін. Компанія жодним чином не контролює ці файли. Якщо вам
      потрібна більш детальна
      інформація про типи Файлів cookie, які в результаті можуть бути завантажені, будь ласка відвідайте Вебсайти третіх
      сторін.
    </li>
    <li>3.3. Інформація, що отримується в автоматичному режимі – дані Користувачів Вебсайту, які автоматично збираються
      Вебсайтом за допомогою сервісів,
      наприклад Google Analytics.
    </li>
    <li>3.4. Під час відвідування будь-яких сторінок Вебсайту Браузером Користувача здійснюється передача інформації про
      Користувача
      інструментам сервісів. В облікових записах сервісів Компанія отримує таку інформацію:
    </li>
    <li>3.4.1. демографічні дані (наприклад, відомості про вік, стать, мову, країну, операційну систему, Браузер);</li>
    <li>3.4.2. дані про інтереси (спорт, ігри і т. д.);</li>
    <li>3.4.3. дані про поведінку (новий клієнт чи повторний, скільки часу Користувач проводить на Вебсайті, кількість
      сторінок);
    </li>
    <li>3.4.4. дані про залучення Користувачів (звідки Користувач дізнався про Сайт – пряме посилання, реферал,
      органічний пошук і т. д.).
    </li>
    <li>3.5. Файли cookie не можуть повідомити Компанії адресу електронної пошти або іншу особисту інформацію
      Користувача до моменту,
      поки Користувач самостійно не вкаже її, наприклад, зареєструвавшись на Вебсайті Компанії. Інформація додається до
      Файлів cookie,
      лише після того як Користувач надав згоду на надання особистих даних.
    </li>
    <li>3.6. Данні з Файлів cookie дозволяють Компанії аналізувати аудиторію Вебсайту. Компанія використовує Файли
      cookie для покращення
      функціональності Вебсайту, виходячи з відомостей про його використання, а також для вдосконалення контенту, роботи
      Вебсайту і
      представлених на них пропозицій, а також для пропонування Користувачам продуктів і послуг.
    </li>
    <li>3.7. Використання Файлів cookie та інформації з них надає Компанії анонімну інформацію про статистику Вебсайту,
      IP-адреси та інформацію
      про Файли cookie, що використовуються, завдяки чому Компанія дізнається, яка кількість людей відвідує Вебсайт,
      скільки з їх числа переглядають
      ті чи інші сторінки, які Браузери вони використовують (що дозволяє вдосконалювати сумісність сервісів для більшої
      кількості людей).
    </li>
  </ul>

  <h4 class="oferta-text-center">4. ВИКОРИСТАННЯ ЗІБРАНОЇ ІНФОРМАЦІЇ</h4>

  <ul>
    <li>4.1. Компанія використовує Файли cookie для наступних цілей:</li>
    <li>4.1.1 забезпечити належний рівень безпеки, а також перевірити та запам’ятати особисті дані Користувачів,
      завдяки чому Користувачам не потрібно вводити їх кожного разу при переходах на нові сторінки;
    </li>
    <li>4.1.2. запам’ятати рішення Користувача про збереження імені Користувача та паролю, щоб уникнути
      повторного введення даних під час кожного відвідування Вебсайту;
    </li>
    <li>4.1.3. запам’ятати, який контент є для Користувача найбільш важливим, що дозволяє змінювати вебсторінки,
      доповнюючи їх інформацією, що може зацікавити Користувача;
    </li>
    <li>4.1.4. гарантувати, що придбання того чи іншого виду Товару чи сервісу через Вебсайт Компанії буде швидким та
      безпечним;
    </li>
    <li>4.1.5. збирати та зберігати анонімну інформацію, яка дозволить Компанії краще зрозуміти,
      яким чином Користувачі використовують Вебсайт та як Компанія може покращити структуру Вебсайту.
    </li>
    <li>4.2. На Вебсайті Компанія використовує як сесійні, так і постійні Файли cookie.</li>
    <li>4.3. Типи Файлів cookie, які можуть використовуватися Компанією протягом сеансу на Вебсайті:</li>
    <li>4.3.1. Файли cookie для персоналізації використовуються для того, щоб дізнатися,
      які Користувачі повертаються на Сайт не вперше, та використовувати інформацію, введену ними раніше (саме тому,
      коли Користувач переглядає на Вебсайті сторінки, що переглядав раніше, йому не потрібно ще раз вводити вказану
      інформацію).
      Ці файли використовуються для рекомендації контенту, який, на думку Компанії, може сподобатися Користувачу.
      Користувач може вимкнути Файли cookie для персоналізації, вийшовши з облікового запису.
    </li>
    <li>4.3.2. Файли cookie для управління Сайтом використовуються для збереження ідентифікаційних даних або сесії на
      Вебсайті.
      Наприклад, коли Вебсайт працює більш ніж на одному сервері, Компанія використовує Файли cookie для того, щоб
      впевнитися,
      що Користувач надіслав інформацію одному конкретному серверу (в іншому випадку Користувач може неочікувано ввійти
      до
      системи або вийти з неї). Також Компанія може використовувати схожі Файли cookie, коли Користувач бере участь в
      голосуванні,
      щоб такий Користувач проголосував один раз та міг використовувати функцію коментування навіть не входячи до
      системи
      (для того, щоб приховати коментарі, які вважаються образливими, а також для того, щоб не голосувати за коментарі
      понад один раз).
      Ці Файли cookie не може бути вимкнено окремо, але Користувач може змінити налаштування свого Браузера для заборони
      всіх
      Файлів cookie, якщо не бажає їх використовувати.
    </li>
  </ul>

  <h4 class="oferta-text-center">5. ВІДМОВА ВІД ФАЙЛІВ СООКІЕ</h4>

  <ul>
    <li>5.1. Звертаємо увагу, що Користувач має можливість відмовитись від використання Файлів cookie, вимкнення Файлів
      cookie
      поширюється не тільки на цей, але й інші вебсайти. Блокування Файлів cookie може негативно вплинути на роботу
      багатьох вебсайтів.
    </li>
    <li>5.2. Для відмови від Файлів cookie Користувачу необхідно змінити налаштування в розділі Браузера.</li>
  </ul>

  <h4 class="oferta-text-center">6. ІНШЕ</h4>

  <ul>
    <li>6.1. Дія Політики щодовикористання файлів cookie поширюється на всі сервіси та функціонал, представлені на
      Вебсайті.
    </li>
    <li>6.2. Компанія залишає за собою право час від часу без попереднього повідомлення вносити зміни до Політики щодо
      файлів cookie.
      З огляду на це Компанія просить Користувачів час від часу перевіряти цю Політику, щоб завжди бути в курсі змін та
      оновлень.
    </li>
    <li>6.3. Для того, щоб задати питання про Політику щодо файлів cookie, Користувач може звернутись до відділу
      технічної підтримки Вебсайту.
    </li>
  </ul>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
